import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";

const AddInventoryProductModal = ({
  isOpen,
  onClose,
  onAddProduct,
  setCode,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [categories, setCategories] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [selectedEventsData, setSelectedEventsData] = useState("");
  const [products, setProducts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [SelectedType, setSelectedType] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [quantities, setQuantities] = useState({});

  const [selectedPricingValue, setSelectedPricingValue] = useState({});
  const [title, setTitle] = useState("");
  const [productCode, setProductCode] = useState("");
  const [category, setcategory] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [dateFilter, setDateFilter] = useState("");

  const [positionFilter, setPositionFilter] = useState(""); // State for tab filter
  const [phoneNumberFilter, setPhoneNumberFilter] = useState("");

  const [promotionFilter, setPromotionFilter] = useState("");
  const [showWebFilter, setShowWebFilter] = useState("");

  const handleButtonClick = (value) => {
    setSelectedType(value);
  };

  const handleButtonClickPromotion = (value) => {
    setPromotionFilter(value);
  };

  const handleButtonClickShowWeb = (value) => {
    setShowWebFilter(value);
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/all-main-category",
        );
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/eventCollection",
        );
        setEventData(response.data);
      } catch (error) {
        console.error("Error fetching EventData:", error);
      }
    };

    fetchCategories();
    fetchEvents();
  }, []);

useEffect(() => {
  const fetchData = () => {
    setLoading(true); // Show loading whenever fetch starts
    setIsLoading(true);

    const page = searchParams.get("page") || 1;
    const dateFilter = searchParams.get("dateFilter") || "";
    const fromDate = searchParams.get("fromDate") || "";
    const toDate = searchParams.get("toDate") || "";
    const phoneNumber = searchParams.get("phoneNumber") || "";
    const category = searchParams.get("category") || "";
    const selectedEventsData = searchParams.get("selectedEventsData") || "";
    const SelectedType = searchParams.get("SelectedType") || "";
    const productCode = searchParams.get("productCode") || "";
    const title = searchParams.get("title") || "";
    const promotionFilter = searchParams.get("promotionFilter") || "";
    const showWebFilter = searchParams.get("showWebFilter") || "";

    const url = `https://server-gs.vercel.app/admin/products?page=${page}&limit=16&dateFilter=${dateFilter}&fromDate=${fromDate}&toDate=${toDate}&phoneNumber=${phoneNumber}&category=${category}&selectedEventsData=${selectedEventsData}&SelectedType=${SelectedType}&productCode=${productCode}&title=${title}&promotionFilter=${promotionFilter}&showWebFilter=${showWebFilter}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setProducts(data.products || []);
        setTotalPages(data.totalPages || 0);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
        setLoading(false); // Hide loading after fetch
      });
  };

  fetchData();
}, [searchParams]);


  const currentPage = parseInt(searchParams.get("page")) || 1;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setSearchParams((prevParams) => {
        prevParams.set("page", nextPage);
        return prevParams;
      });
      setLoading(true);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setSearchParams((prevParams) => {
        prevParams.set("page", prevPage);
        return prevParams;
      });
      setLoading(true);
    }
  };

  const handleApplyFilters = () => {
    setSearchParams((prevParams) => {
      if (dateFilter) prevParams.set("dateFilter", dateFilter);
      if (fromDate) prevParams.set("fromDate", fromDate);
      if (toDate) prevParams.set("toDate", toDate);
      if (phoneNumberFilter) prevParams.set("phoneNumber", phoneNumberFilter);
      if (category) prevParams.set("category", category);
      if (selectedEventsData)
        prevParams.set("selectedEventsData", selectedEventsData);
      if (SelectedType) prevParams.set("SelectedType", SelectedType);
      if (productCode) prevParams.set("productCode", productCode);
      if (title) prevParams.set("title", title);
      if (promotionFilter) prevParams.set("promotionFilter", promotionFilter);
      if (showWebFilter) prevParams.set("showWebFilter", showWebFilter);

      prevParams.set("page", 1);
      return prevParams;
    });
    setLoading(true);
  };

  const handleCancelFilters = () => {
    setDateFilter("");
    setFromDate("");
    setToDate("");
    setPhoneNumberFilter("");
    setcategory("");
    setSelectedEventsData("");
    setSelectedType("");
    setProductCode("");
    setTitle("");
    setPromotionFilter("");
    setShowWebFilter("");
    setSearchParams({ page: 1 });
  };
  // Handle quantity changes
  const handleIncrement = (id) => {
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [id]: (prevQuantities[id] || 1) + 1,
    }));
  };

  const handleDecrement = (id) => {
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [id]: Math.max((prevQuantities[id] || 1) - 1, 1),
    }));
  };

  const handleAddProduct = (
    productId,
    singleImage,
    title,
    description,
    perDayPricing,
    color,
    Event,
    height,
    length,
    width,
    shape,
    measurement,
    productCode,
    internalNotes,
  ) => {
    // const productCode = generateRandomId();
    const selectedQuantity = quantities[productId] || 1;

    const newProduct = {
      productId,
      singleImage,
      title,
      quantity: selectedQuantity,
      description,
      perDayPricing,
      tax: data?.taxValue || 0,
      selectedPricingValue: selectedPricingValue[productId] || perDayPricing,
      color,
      Event,
      height,
      length,
      width,
      shape,
      measurement,
      productCode,
      internalNotes,
    };

    onAddProduct(setCode, newProduct);
    onClose();
  };

  if (!isOpen) return null;




  return (
    <>

      <div className={`overlay ${isOpen ? "open" : ""}`} onClick={onClose} />
      <div className={`modal-container ${isOpen ? "open" : ""}`}>
        <div className="bg-white  rounded-lg w-full h-full">
          <div className="flex justify-between items-center bg-blue-600 px-6 py-4">
            <h2 className="text-xl font-bold font-roboto text-white">
              Add New Product
            </h2>
            <button
              onClick={onClose}
              aria-label="Close modal"
              className="w-9 h-9 rounded-full flex justify-center items-center transition hover:bg-blue-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="bg-green  overflow-y-auto flex flex-row">
            <div className="w-[400px] h-[800px] bg-gray-50">
              {/* Category select */}
              <div className="flex flex-col p-5">
                <label className="lg:text-md sm:text-sm md:text-sm font-roboto text-gray-700">
                  Product Category
                </label>
                <select
                  value={category}
                  onChange={(e) => setcategory(e.target.value)}
                  className="text-gray-700 bg-white h-10 w-full rounded mt-2 p-2 text-sm font-roboto"
                >
                  <option value="">Select a category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category._id}>
                      {category.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="p-5">
                <label className="lg:text-md sm:text-sm md:text-sm font-roboto text-gray-700">
                  Product Code
                </label>
                <input
                  type="text"
                  value={productCode}
                  onChange={(e) => setProductCode(e.target.value)}
                  className="border border-gray-300 text-gray-700 bg-white h-10 w-full rounded mt-2 p-2 text-sm font-roboto"
                  placeholder="Enter Product Code"
                />
              </div>
              <div className="p-5">
                <label className="lg:text-md sm:text-sm md:text-sm font-roboto text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="border border-gray-300 text-gray-700 bg-white h-10 w-full rounded mt-2 p-2 text-sm font-roboto"
                  placeholder="Enter Product Title"
                />
              </div>

              <div className="p-4 w-full">
                <div className="w-full flex flex-col gap-5">
                  <button
                    onClick={() => handleButtonClick("package")}
                    className={`px-4 py-2 w-full border rounded font-roboto  text-md  ${
                      SelectedType === "package"
                        ? " text-black bg-gray-100 border-gray-700"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    Package
                  </button>
                  <button
                    onClick={() => handleButtonClick("product")}
                    className={`px-4 py-2 w-full border rounded ${
                      SelectedType === "product"
                        ? " text-black bg-gray-100 border-gray-700"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    Product
                  </button>
                </div>
              </div>

              <div className="p-4 w-full">
                <div className="w-full flex flex-col gap-5">
                  <button
                    onClick={() => handleButtonClickPromotion("true")}
                    className={`px-4 py-2 w-full border rounded font-roboto  text-md  ${
                      promotionFilter === "true"
                        ? " text-black bg-gray-100 border-gray-700"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    Showing Promotion
                  </button>
                  <button
                    onClick={() => handleButtonClickShowWeb("true")}
                    className={`px-4 py-2 w-full border rounded ${
                      showWebFilter === "true"
                        ? " text-black bg-gray-100 border-gray-700"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    Showing Website
                  </button>
                </div>
              </div>

              <div className="flex flex-row gap-5 p-5">
                <button
                  onClick={handleApplyFilters}
                  className="bg-blue-700 rounded text-white font-roboto text-md w-full h-10"
                >
                  Apply Filters
                </button>
                <button
                  onClick={handleCancelFilters}
                  className="bg-gray-400 rounded text-white font-roboto text-md w-full h-10"
                >
                  Cancel Filters
                </button>
              </div>
            </div>
                {loading && (
      <div className="w-full h-[800px] flex justify-center items-center ">
        <span className="text-lg font-semibold">Loading...</span>
      </div>
    )}
    {!loading && (
      <>
        <div className="border border-gray-200 h-[800px] overflow-auto w-full">
              <div className="relative overflow-x-auto w-full">
                <table className="w-full text-sm  text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3">
                        Title
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Product Code
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Available Quantity
                      </th>

                      <th scope="col" className="px-6 py-3">
                        Price
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Quantity
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product) => (
                      <tr
                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                        key={product.id}
                      >
                        <td className="px-6 py-4">
                          <div className="flex flex-row gap-2 items-center">
                            <img
                              className="w-24 h-24 rounded-full"
                              src={product.singleImage}
                              alt="Rounded avatar"
                            />
                            <span className="font-semibold">
                              {product.title}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4">{product?.productCode}</td>
                        <td className="px-6 py-4">
                          {product.categoryTitle},{product.subCategoryTitle}
                        </td>
                        {/* <td class="lg:px-6 md:px-4 sm:px-2 lg:py-3 md:py-2 sm:py-2">
                          {product.availableQuantity === 2 ? (
                            <button
                              type="button"
                              class="relative w-full gap-5 inline-flex  items-center px-7 py-2.5 text-md font-medium text-center text-white bg-orange-500 rounded-lg hover:bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            >
                              <img
                                className="w-6"
                                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMzMgMzMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xNC41OCAzLjIwNWMxLjA1Ny0xLjgyOSAyLjc4My0xLjgyOSAzLjgzOCAwbDEzLjYzMSAyNC42NGMxLjA1NyAxLjgyNy4xOTEgMy4zMjItMS45MiAzLjMyMkgyLjg3MWMtMi4xMTIgMC0yLjk3Ni0xLjQ5NS0xLjkyMi0zLjMyMnoiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiNmN2MzMjUiIGNsYXNzPSIiPjwvcGF0aD48ZyBmaWxsPSIjMjczMTRkIj48cGF0aCBkPSJNMTYuNSA5Ljk2Yy0xLjI1NiAwLTIuNjQ0Ljk3My0yLjUyMiAyLjU0MkwxNSAyMS44NDdjLjA0LjY0Ny4yNDQgMS40NjcgMS41IDEuNDY3IDEuMjU0IDAgMS40NTktLjgxOSAxLjUtMS40NjdsMS4wMjEtOS4zNDRjLjEyMi0xLjU3LTEuMjY3LTIuNTQzLTIuNTIxLTIuNTQzeiIgZmlsbD0iI2ZmYTUwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzI3MzE0ZCIgY2xhc3M9IiI+PC9wYXRoPjxjaXJjbGUgY3g9IjE2LjQ5OSIgY3k9IjI2Ljg2MyIgcj0iMS44MzEiIGZpbGw9IiNmZmE1MDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMyNzMxNGQiIGNsYXNzPSIiPjwvY2lyY2xlPjwvZz48L2c+PC9zdmc+"
                              />
                              Upgrade stock
                              <div class="absolute inline-flex items-center  justify-center w-8 h-8 text-md font-bold text-white bg-red-900 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
                                {product.availableQuantity}
                              </div>
                            </button>
                          ) : product.availableQuantity <= 0 ? (
                            <button
                              type="button"
                              class="relative w-full inline-flex gap-4 items-center px-7 py-2.5 text-md font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            >
                              <img
                                className="w-6"
                                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PGVsbGlwc2UgY3g9IjI1NiIgY3k9IjI1NiIgcng9IjI1NiIgcnk9IjI1NS44MzIiIHN0eWxlPSIiIGZpbGw9IiNmZmZmZmYiIGRhdGEtb3JpZ2luYWw9IiNlMjFiMWIiIGNsYXNzPSIiIG9wYWNpdHk9IjEiPjwvZWxsaXBzZT48cGF0aCBkPSJNMjI4LjAyMSAxMTMuMTQzaDU1Ljk5MXYyODUuNjY5aC01NS45OTF6IiBzdHlsZT0iIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUuMDAxIDI1Ni4wMTUgMjU1Ljk4MikiIGZpbGw9IiNmZjAwMDAiIGRhdGEtb3JpZ2luYWw9IiNmZmZmZmYiIGNsYXNzPSIiIG9wYWNpdHk9IjEiPjwvcGF0aD48cGF0aCBkPSJNMTEzLjE2NCAyMjcuOTY4aDI4NS42Njl2NTUuOTkxSDExMy4xNjR6IiBzdHlsZT0iIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUuMDAxIDI1NS45OTcgMjU1Ljk2OCkiIGZpbGw9IiNmZjAwMDAiIGRhdGEtb3JpZ2luYWw9IiNmZmZmZmYiIGNsYXNzPSIiIG9wYWNpdHk9IjEiPjwvcGF0aD48L2c+PC9zdmc+"
                              />
                              Out of stock
                              <div class="absolute inline-flex items-center justify-center w-8 h-8 text-md font-bold text-white bg-red-900 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
                                {product.availableQuantity}
                              </div>
                            </button>
                          ) : (
                            <button
                              type="button"
                              class="relative w-full inline-flex gap-4 items-center px-7 py-2.5 text-md font-medium text-center text-white bg-gray-700 rounded-lg hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            >
                              <img
                                className="w-6"
                                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTTEyNCA2NGMwIDUuMTItNi4yOSA5LjM0LTcuNTUgMTQuMDYtMS4zIDQuODggMS45OSAxMS42OC0uNDggMTUuOTUtMi41MSA0LjM0LTEwLjA2IDQuODYtMTMuNTggOC4zOHMtNC4wNCAxMS4wNy04LjM4IDEzLjU4Yy00LjI3IDIuNDctMTEuMDctLjgyLTE1Ljk1LjQ4QzczLjM0IDExNy43MSA2OS4xMiAxMjQgNjQgMTI0cy05LjM0LTYuMjktMTQuMDYtNy41NWMtNC44OC0xLjMtMTEuNjggMS45OS0xNS45NS0uNDgtNC4zNC0yLjUxLTQuODYtMTAuMDYtOC4zOC0xMy41OHMtMTEuMDctNC4wNC0xMy41OC04LjM4Yy0yLjQ3LTQuMjcuODItMTEuMDctLjQ4LTE1Ljk1QzEwLjI5IDczLjM0IDQgNjkuMTIgNCA2NHM2LjI5LTkuMzQgNy41NS0xNC4wNmMxLjMtNC44OC0xLjk5LTExLjY4LjQ4LTE1Ljk1IDIuNTEtNC4zNCAxMC4wNi00Ljg2IDEzLjU4LTguMzhzNC4wNC0xMS4wNyA4LjM4LTEzLjU4YzQuMjctMi40NyAxMS4wNy44MiAxNS45NS0uNDhDNTQuNjYgMTAuMjkgNTguODggNCA2NCA0czkuMzQgNi4yOSAxNC4wNiA3LjU1YzQuODggMS4zIDExLjY4LTEuOTkgMTUuOTUuNDggNC4zNCAyLjUxIDQuODYgMTAuMDYgOC4zOCAxMy41OHMxMS4wNyA0LjA0IDEzLjU4IDguMzhjMi40NyA0LjI3LS44MiAxMS4wNy40OCAxNS45NUMxMTcuNzEgNTQuNjYgMTI0IDU4Ljg4IDEyNCA2NHoiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMyNTY4ZWYiIGNsYXNzPSIiPjwvcGF0aD48cGF0aCBmaWxsPSIjMDAwMGZmIiBkPSJNODEuMzQgNDYuMTIgNTguNSA2OC45NiA0Ni42NiA1Ny4xM2E2LjU4NSA2LjU4NSAwIDAgMC05LjMxIDAgNi41ODUgNi41ODUgMCAwIDAgMCA5LjMxbDE2LjYxIDE2LjYxYTYuNDEgNi40MSAwIDAgMCA5LjA2IDBsMjcuNjItMjcuNjJhNi41ODUgNi41ODUgMCAwIDAgMC05LjMxIDYuNTczIDYuNTczIDAgMCAwLTkuMyAweiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iI2ZmZmNlZSIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                              />
                              in stock
                              <div class="absolute inline-flex items-center justify-center w-8 h-8 text-md font-bold text-white bg-red-900 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
                                {product.availableQuantity}
                              </div>
                            </button>
                          )}
                        </td> */}

                        <td className="px-6 py-4">{product?.perDayPricing}</td>
                        <td className="px-6 py-4 flex flex-col gap-2 items-center">
                          <div className="relative flex items-center max-w-[12rem]">
                            <button
                              onClick={() => handleDecrement(product.productId)}
                              type="button"
                              className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900 dark:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 2"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M1 1h16"
                                />
                              </svg>
                            </button>
                            <span className="bg-gray-50 flex justify-center items-center border-x-0 w-10 border-gray-300 h-10 text-center text-gray-900 text-xl font-roboto focus:ring-blue-500 focus:border-blue-500 py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                              {quantities[product.productId] || 1}
                            </span>
                            <button
                              onClick={() => handleIncrement(product.productId)}
                              type="button"
                              className="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                            >
                              <svg
                                className="w-3 h-3 text-gray-900 dark:text-white"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 18"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 1v16M1 9h16"
                                />
                              </svg>
                            </button>
                          </div>
                          <button
                            className="w-full rounded text-md py-2 bg-blue-600 font-roboto text-white"
                            onClick={() =>
                              handleAddProduct(
                                product.productId,
                                product.singleImage,
                                product.title,
                                product.productDescription,
                                product.perDayPricing,
                                product.color,
                                product.Event,
                                product.height,
                                product.length,
                                product.width,
                                product.shape,
                                product.measurement,
                                product.productCode,
                                product.internalNotes,
                              )
                            }
                          >
                            Add
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex my-4 items-center justify-center gap-5">
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  className="flex items-center justify-center px-3 h-8 me-3 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  <svg
                    className="w-3.5 h-3.5 me-2 rtl:rotate-180"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 5H1m0 0 4 4M1 5l4-4"
                    />
                  </svg>
                  Previous
                </button>
                <span className="font-roboto font-semibold text-sm">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  className="flex items-center justify-center px-3 h-8 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  Next
                  <svg
                    className="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </button>
              </div>
            </div>
      </>
    )}
            
          </div>
        </div>
      </div>
    </>
  );
};

export default AddInventoryProductModal;
